<template>
    <header class="header">
        <div class="content">
            <div class="left">
                <div class="logo">
                    <img
                        :src="webInfo.logoUrl"
                        alt="logo"
                    >
                </div>
            </div>

            <div class="right">
                <div class="nav">
                    <a
                        v-for="(item, index) in navList"
                        :key="index"
                        class="nav-item"
                        :class="{active: item.active.test($route.path)}"
                        :href="item.url"
                        @click.prevent="clickHandler(item)"
                    >
                        {{item.title}}
                    </a>
                </div>

                <div class="info">
                    <div class="phone">
                        <i class="iconfont">&#xe8be;</i>
                        {{ webInfo.mobile}}
                    </div>

                    <div class="btn">
                        <!-- <el-button
                            size="small"
                            type="primary"
                            round
                            @click="tryHandler"
                        >立即体验</el-button> -->

                        
                        <a :href="webInfo.signUrl">
                            <el-button
                                size="small"
                                type="primary"
                                round
                            >
                                免费注册
                            </el-button>
                        </a>

                        <a :href="webInfo.loginUrl" class="primary-a">
                            <el-button
                                size="small"
                                plain
                                type="primary"
                                round
                                class="btn2"
                            >
                                登录
                            </el-button>
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </header>
</template>

<script>
export default {
    data() {
        return {
            navList: [
                {
                    title: '首页',
                    url: '/',
                    active: /\/$/,
                },
                {
                    title: '解决方案',
                    url: '/serve',
                    active: /serve/,
                },
                {
                    title: '采购信息',
                    url: '/noticesys',
                    active: /notice/,
                },
                {
                    title: '新闻公告',
                    url: '/news',
                    active: /news/,
                },
                {
                    title: '帮助中心',
                    url: '/help',
                    active: /help/,
                },
                {
                    title: '下载中心',
                    url: '/download',
                    active: /download/,
                },
                {
                    title: 'CA在线办理',
                    url: 'http://hebcaonline.hebca.com:9001/Hebca/certbussconduct/entry.action?onlineType=4&projectType=zbrhah&cztype=1',
                    active: /ca-online-buy/,
                },
                {
                    title: '关于我们',
                    url: '/about',
                    active: /about/,
                },
            ],
        };
    },
    methods: {
        clickHandler(item) {
            if (item.click) {
                item.click();
                return;
            }

            if (/http/.test(item.url)) {
                window.open(item.url);
                return;
            }

            if (item.click) {
                item.click();
                return;
            }

            this.goto(item.url);
        },
        tryHandler() {
            this.$store.commit('global-dialog/updateDialogVisible', {
                name: 'reservation',
                visible: true,
            });
        },
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/hzc.scss';

.header {
    display: flex;
    align-items: center;
    height: 70px;

    .content {
        display: flex;
        height: 100%;

        .left {
            display: flex;
            align-items: center;

            .logo {
                margin-top: 5px;
                img {
                    height: 42px;
                }
            }
        }

        .right {
            flex: 1;
            display: flex;
            margin-left: 50px;

            .nav {
                display: flex;
                flex: 1;

                .nav-item {
                    display: flex;
                    align-items: center;
                    font-size: 16px;
                    color: #131415;
                    padding: 0 10px;
                    cursor: pointer;
                    height: 100%;

                    &.active,
                    &:hover {
                        color: $primaryColor;
                        position: relatice;

                        &:after {
                            content: '';
                            display: block;
                            width: 100%;
                            height: 4px;
                            background: $primaryColor;
                            position: absolute;
                            bottom: 0;
                            left: 0;
                        }
                    }

                    & + .nav-item {
                        margin-left: 4px;
                    }
                }
            }

            .info {
                display: flex;
                align-items: center;
                margin-left: 20px;

                .phone {
                    display: flex;
                    align-items: center;
                    color: #232323;
                    margin-right: 1em;
                    cursor: default;

                    .iconfont {
                        color: $primaryColor;
                        font-size: 22px;
                        margin-right: 6px;
                    }
                }

                .btn{
                    a{
                        color: #fff;
                        margin-left: 5px;
                    }
                    .el-button{
                        border: 1px solid $primaryColor;
                    }
                    .primary-a{
                        color: $primaryColor;
                        &:hover{
                           color: $primaryColor9; 
                        }
                    }
                }
            }
        }
    }
}
</style>